import { useSelector } from "react-redux";
import { DASHBOARD_MENU, SETTINGS_MENU, filterMenuByPermissions } from "../configs/menuConfig";

const useDashboardMenu = () => {
  const { permissions, role: userType } = useSelector((state) => state.user);
  const user = useSelector((state) => state?.user?.userInfo?.user || state?.user?.user);

  // Filter menus based on permissions (pass user for is_team_manager check)
  const filteredDashboardMenu = filterMenuByPermissions(DASHBOARD_MENU, permissions, userType, user);
  const filteredSettingsMenu = filterMenuByPermissions(SETTINGS_MENU, permissions, userType, user);

  return {
    settingMenu: filteredSettingsMenu,
    dashboardMenu: filteredDashboardMenu,
  };
};

export default useDashboardMenu;
